export const ALLOWED_AGENTS = [
  { cadre: "AWW", kb: "WCD", approach: "PAGE_SEARCH" },
  { cadre: "ASHA", kb: "DEMO", approach: "PAGE_SEARCH" },
  { cadre: "ASHA", kb: "GAVI", approach: "PAGE_SEARCH" },
  { cadre: "FPC", kb: "BSHS", approach: "PAGE_SEARCH" },
  { cadre: "ANM", kb: "POC", approach: "PAGE_SEARCH" },
];

export function getCadreOptions() {
  return [...new Set(ALLOWED_AGENTS.map((a) => a.cadre))];
}

export function getKbOptionsForCadre(cadre) {
  if (!cadre) return [];
  return [...new Set(ALLOWED_AGENTS.filter((a) => a.cadre === cadre).map((a) => a.kb))];
}

export function getApproachForCadreKb(cadre, kb) {
  return ALLOWED_AGENTS.find((a) => a.cadre === cadre && a.kb === kb)?.approach || "";
}
